<script setup>
import { computed, onMounted, ref } from 'vue'
import { socialShareImage, usePageHead } from '@composables/use-page-head'
import { useRoute } from 'vue-router'
import DataLayer from '@services/data-layer/index'

const route = useRoute()

const loadedArtist = ref({})

const latestMixes = ref(Array.from(Array(6), (_mix, id) => ({ id, genre: [] })))
const popularMixes = ref(Array.from(Array(6), (_mix, id) => ({ id, genre: [] })))


const latestMix = computed(() => latestMixes.value[0])

const heroArtist = computed(() => ({ ...loadedArtist.value, latestMix: latestMix.value }))

const tabs = computed(() => {
    const artistUrl = loadedArtist.value.url
    // Route params are strings by default; matching the active tab depends on it.
    const id = String(loadedArtist.value.id)
    return [
        { to: { name: 'artist', params: { artistUrl, id } }, label: 'Overview' },
        { to: { name: 'artist/about', params: { artistUrl, id } }, label: 'About' },
    ]
})

onMounted(() => {
    Promise.all([
        DataLayer.artists.getById(route.params.id),
        DataLayer.mixes.getPopularByArtist(route.params.id),
        DataLayer.mixes.getLatestByArtist(route.params.id),
    ]).then(([artistResponse, popular, latest]) => {
        loadedArtist.value = artistResponse.body
        popularMixes.value = popular.body
        latestMixes.value = latest.body
    })
})

usePageHead(computed(() => {
    const artist = loadedArtist.value
    const title = artist.title || 'Artist'
    const genre = artist.genre?.length ? artist.genre[0] : ''
    const biography = artist.biography

    return {
        title,
        description: biography
            ? (biography.length > 200 ? `${biography.substring(0, 200)}...` : biography)
            : `Listen to ${title} on FRISKY${genre ? ' • ' + genre : ''}`,
        image: artist.hero?.url || artist.photo?.url || socialShareImage(),
        type: 'music.song',
    }
}))
</script>

<template>
    <div>
        <BaseHero
            :resource="heroArtist"
            resource-type="artist"
        />
        <BaseTabPanel
            :tabs="tabs"
            class="tabs"
            is-unpadded
            address-navigation
        />
        <BaseContent>
            <NuxtPage
                :artist="loadedArtist"
                :popular-mixes="popularMixes"
                :latest-mixes="latestMixes"
            />
        </BaseContent>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.tabs {
    @include tablet {
        padding-bottom: $s-xxl;
    }
}
</style>
